import * as React from 'react';

import type {ActionBarActionEnum} from 'nutshell-graphql-types';
import type {ChatActionsFragment} from 'nutshell-graphql-types';

import {ChatActionButton} from './chat-action-button';
import {ACTION_CONFIG} from './consts';

type Props = {
    shownActions: ActionBarActionEnum[];
    actionsDetails: ChatActionsFragment;
    backgroundColor: string;
    isOpen: boolean;
    shouldSelectAction?: boolean;
};

// Action bar for the chat preview
export function ChatActionBar(props: Props) {
    const options = React.useMemo(() => {
        return props.shownActions.map((action) => {
            const config = ACTION_CONFIG[action];
            const fragmentData = props.actionsDetails[config.fragmentKey];

            return {
                action: config.action,
                label: fragmentData && fragmentData.label ? fragmentData.label : config.action,
                icon: config.icon,
            };
        });
    }, [props.shownActions, props.actionsDetails]);

    if (!options) {
        return null;
    }

    return (
        <div className='flex justify-end align-center'>
            <div
                className='flex justify-center align-end width-fit-content max-full-width br-8 gap-8 px-8'
                style={{backgroundColor: props.backgroundColor}}
            >
                {options.map((option) => (
                    <ChatActionButton
                        key={option.action}
                        label={option.label}
                        icon={option.icon}
                        isSelected={
                            props.shouldSelectAction === false
                                ? false
                                : props.isOpen && option.action === 'CHAT_ACTION'
                        }
                    />
                ))}
            </div>
        </div>
    );
}
